module.exports = __webpack_public_path__ + "img/will_being_read.10b10e61.svg";